<template>
<div class="page cover-page is-flex is-flex-direction-column is-justify-content-space-between">
  <div style="flex: 1 1 0">
    <div class="pl-3" style="border-left: 4px solid #363636">
      <p class="dustin-title pb-3">
        Impact Report
      </p>

      <p class="preheader">
        {{ portfolio.name }}
      </p>

      <p class="subtitle" v-if="portfolio.impact_report">
        {{ portfolio.impact_report && portfolio.impact_report.firm.name }}
      </p>

      <p>
        {{ new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(new Date()) }}
      </p>
    </div>
  </div>

  <div class="mx-auto">
    <figure class="image">
      <img
        class="imgsize"
        v-bind:src="portfolio.impact_report && portfolio.impact_report.firm.logo">
    </figure>
  </div>

  <div class="cover-page-footer">
    <div>
      <small><em>Data Powered by</em></small>
      <img
        v-bind:src="$root.$data.STATIC_ROOT + 'images/yourstakelogo.png'"
        alt="Stake: Your Voice through Your Investments"
        width="110" height="55">
    </div>
  </div>
</div>
</template>

<script>
  export default {
    data () {
      return {
        interestingNumber: 3.14
      }
    },
    methods: {
      randomize: function() {
        this.interestingNumber = Math.random() * Math.random();
      }
    },
    props: {
      portfolio: {},
    },
    components: {}
  }
</script>

<style lang="css" scoped>
  .imgsize {
    max-width: 20rem;
    max-height: 20rem;
  }
  .page {
    position: relative;
  }
  .cover-page-footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1 1 0;
  }
</style>
